exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-70ee0748] .el-loading-mask{background:-webkit-gradient(linear,left top,left bottom,from(rgba(8,34,57,.9)),color-stop(93.96%,rgba(3,25,43,.9)));background:linear-gradient(180deg,rgba(8,34,57,.9),rgba(3,25,43,.9) 93.96%)}", ""]);

// exports
